import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';

export function useRequireAuthRedirect() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoadingAuth } = useAuth();

  useEffect(() => {
    if (!isLoadingAuth && !isAuthenticated) {
      navigate('/Login', { replace: true });
    }
  }, [isAuthenticated, isLoadingAuth, navigate]);

  return {
    isAuthenticated,
    isLoadingAuth,
    canRenderProtectedContent: !isLoadingAuth && isAuthenticated,
  };
}